/**
 * Created by Ning Jiang on 11/17/2016.
 */

import ("pixi.js");
declare global {
    interface Window {
        PIXI:any;
    }
}
import * as PIXI from "pixi.js";
window.PIXI = PIXI;
require("pixi-spine");
require("pixi-particles");


import {gsap} from "gsap";
import {CustomEase} from "gsap/dist/CustomEase";
import {CustomWiggle} from "gsap/dist/CustomWiggle";
import {PixiPlugin} from "gsap/dist/PixiPlugin";
PixiPlugin.registerPIXI(PIXI);
gsap.registerPlugin(CustomEase, CustomWiggle, PixiPlugin);

import {XwaysHoarder2} from "./game/XwaysHoarder2";
import {NolimitLauncher} from "@nolimitcity/slot-launcher/bin/NolimitLauncher";
import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";
import {NolimitGameIntroPlugin} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/NolimitGameIntroPlugin";
import {NolimitSlotAudio} from "@nolimitcity/slot-audio/bin/NolimitSlotAudio";
import {NolimitPromotionPlugin} from "@nolimitcity/promo-panel/bin/NolimitPromotionPlugin";
import {LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {XwaysHoarder2IntroConfig} from "./game/intro/XwaysHoarder2IntroConfig";
import {XwaysHoarder2PromoPanelConfig} from "./game/XwaysHoarder2PromoPanelConfig";

declare global {
    interface Window {
        NolimitLauncher:NolimitLauncher;
    }
}
window.NolimitLauncher = NolimitLauncher.instance;
NolimitLauncher.instance.settings.log = LogLevel.DEV;
NolimitLauncher.instance.launch([
    new XwaysHoarder2(),
    new SlotKeypad(),
    new NolimitGameIntroPlugin(new XwaysHoarder2IntroConfig()),
    new NolimitSlotAudio(),
    new NolimitPromotionPlugin(new XwaysHoarder2PromoPanelConfig())
]);
